import {initialState} from "./initialState";

export default function inputReducer(state = initialState.guessdigit, action) {
  switch (action.type) {
    default:
      return state;
  }
}
